import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Vastuvõetud", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Kuupäev "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Kellaeg "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Teema "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Sisu eelvaade "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Manused ")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Saadetud", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Kuupäev "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Kellaeg "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Teema "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Sisu eelvaade "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Manused ")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_KRHPPaigutus = _resolveComponent("KRHPPaigutus")!

  return (_openBlock(), _createBlock(_component_KRHPPaigutus, {
    lehePealkiri: "Teavitused/Pöördumised",
    portaaliPealkiri: "Kriminaalhooldusportaal"
  }, {
    body: _withCtx(() => [
      _createVNode(_component_v_container, { class: "ma-2 pa-2" }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_v_table, null, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_v_table, null, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}